var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group form-group--read-only" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { class: `col-sm-${_vm.component.size}` }, [
        !_vm.component.hideLabel
          ? _c("label", [_vm._v(_vm._s(_vm.component.label))])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "lead" },
          _vm._l(_vm.value, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "row",
                staticStyle: { padding: "0 15px" },
              },
              [
                _c("div", { staticClass: "file-read-only-download-card" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6" }, [
                      _c(
                        "span",
                        {
                          staticClass: "name",
                          staticStyle: { "font-weight": "600" },
                        },
                        [_vm._v(_vm._s(item.name))]
                      ),
                    ]),
                    _c("div", { staticClass: "col-6 text-right" }, [
                      _c("span", { staticClass: "size" }, [
                        _vm._v(_vm._s(_vm.bytesToSize(item.size))),
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link",
                          on: {
                            click: function ($event) {
                              return _vm.onOpen(item.url, item.name)
                            },
                          },
                        },
                        [
                          _vm._v("\n                  DOWNLOAD "),
                          _c("span", {
                            staticClass: "glyphicon glyphicon-save",
                          }),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }